import { Component, OnInit } from '@angular/core';
import {loadStripe} from '@stripe/stripe-js';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-form',
  templateUrl: './card-form.component.html',
  styleUrls: ['./card-form.component.scss'],
})
export class CardFormComponent implements OnInit {
  stripe: any;
  elements: any;
  style = {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };
  card: any;
  uid: string;
  name: string;
  constructor(private authService: AuthService, private router: Router) {

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.uid = user.uid;
        
        
        this.authService.getUserProfile(this.uid).on('value', snapshot => {
          if (snapshot.val() != null) {
            this.name = snapshot.val().name;
          }
        });
      } else {
        this.router.navigateByUrl('sign-in');
      }
    });

    this.stripe = loadStripe('pk_test_Q0ZvkKS5qrgtX94RPFEJpzlm')
    this.elements = this.stripe.elements();
    this.card = this.elements.create('car', {style: this.style});
    this.card.mount('#card-element');
  }

  ngOnInit() {}

}
